// packages/world-model/src/entities/index.ts

export { IFEntity } from './if-entity';
export { EntityStore } from './entity-store';
export { EntityType, isEntityType, getEntityTypePrefix } from './entity-types';
export type { EntityType as EntityTypeValue } from './entity-types';
export { WallEntity } from './wall-entity';
export type { IWallEntity, IWallSideData, IWallSpec, IWallsSpec } from './wall-entity';
